import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ReembolsoService {
  rut: string;
  headers: HttpHeaders = new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService
  ) { }

  // Reembolso
  async getBoletaDuplicada(boleta) {
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.post(
        `${ config['endpoint'] }/Reembolso/EsBoletaDuplicada`, boleta, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getDatosCotizante() {
    this.rut = localStorage.getItem('cbRutCliente');
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.get(
        `${ config['endpoint'] }/Reembolso/ObtenerDatosCotizante?rut=${this.rut}`, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async postSolicitudReembolso(iReembolso) {
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.post(
        `${ config['endpoint'] }/Reembolso/InsertarSolicitudReembolso`, iReembolso, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getHistorialReembolsos(iReembolso) {
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.post(
        `${ config['endpoint'] }/Reembolso​/TraeHistorialReembolsos`, iReembolso, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getEspecialidadMedica() { //Revisar
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.get(
        `${ config['endpoint'] }/Reembolso/ConsultaEspMedicas`, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getReembolsoFull(iReembolso) { //Revisar
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.post(
        `${ config['endpoint'] }/Reembolso/ObtenerReembolsoFull`, iReembolso, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  // Solicitud Reembolso
  async getEstadoSolicitudReembolsoWS() {
    this.rut = localStorage.getItem('cbRutCliente');
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.get(
        `${ config['endpoint'] }/SolicitudReembolso/EstadoWsSolReembolso?rut=${this.rut}`, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getDatosContacto() {
    this.rut = localStorage.getItem('cbRutCliente');
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.get(
        `${ config['endpoint'] }/SolicitudReembolso/ObtenerDatosContacto?rut=${this.rut}`, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getBancos() {
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.get(
        `${ config['endpoint'] }/SolicitudReembolso/ObtenerListadoBancos`, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getDatosBancarios() {
    this.rut = localStorage.getItem('cbRutCliente');
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.get(
        `${ config['endpoint'] }/SolicitudReembolso/ObtenerCtaBancariaCliente?rut=${this.rut}`, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getDatosUbicacionSucursal() {
    this.rut = localStorage.getItem('cbRutCliente');
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.get(
        `${ config['endpoint'] }/SolicitudReembolso/ObtenerDatosUbicacionSucursal?rut=${this.rut}`, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getComunasSucursales(codRegion) {
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.get(
        `${ config['endpoint'] }/SolicitudReembolso/ObtenerComunasSucursales?codRegion=${codRegion}`, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getSucursales(codComuna) {
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.get(
        `${ config['endpoint'] }/SolicitudReembolso/ObtenerSucursales?codComuna=${codComuna}`, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async putCelular(iBeneficiario) {
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.put(
        `${ config['endpoint'] }/SolicitudReembolso/ModificarCelular`, iBeneficiario, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async putEmail(iBeneficiario) {
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.put(
        `${ config['endpoint'] }/SolicitudReembolso/ModificarEmail`, iBeneficiario, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async putCuentaBancaria(iBeneficiario) {
    const config = await this.config.getConfig();

    try {
      return await this.httpClient.put(
        `${ config['endpoint'] }/SolicitudReembolso/ModificarCuentaBancaria`, iBeneficiario, { headers: this.headers }
      ).toPromise();

    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }
}
